import https from '@/utils/axios';
let obj = {}
obj.deletePlasticRawMaterial = function (params) {
  return https.post("/restApi/plasticRawMaterial/delete", params)
}
obj.getUserInfo = function (params) {
  return https.post("/restApi/member/info", params)
}
obj.logout = function () {
  return https.post("/restApi/member/cancellationOfLanding")
}
// 消息通知-全部消息
obj.allNotificationList = function (params) {
  return https.post("/restApi/notification/list", params)
}
// 已上线产品-批量上下架
obj.setStatusBatch = function (params) {
  return https.post(`/restApi/plasticRawMaterial/setStatusBatch/${params.id}/${params.status}`)
}
// 已上线产品-批量删除
obj.deleteBatch = function (params) {
  return https.post(`/restApi/plasticRawMaterial/deleteBatch/${params.id}`)
}
// 已上线产品-批量更新
obj.addBatch = function (params) {
  return https.post(`/restApi/updateRecord/addBatch/${params.plasticRawMaterialId}`)
}
// 查询品号厂家搜索
obj.authall = function (params) {
  return https.post(`/restApi/mark/auth/all`,params)
}
// 查询品号搜索
obj.authlist = function (params) {
  return https.post(`/restApi/product/auth/list`,params)
}
// /restApi/updateRecord/add

// 登录
obj.userCode = function (params) {
  return https.post(`/restApi/member/auth/scanLogin`,params)
}

// 登录-重置密码
obj.resetPwd = function (params) {
  return https.post(`/restApi/member/auth/resetPwd`, params)
}
// 登录-获取验证码
obj.getSmsCodeByAliyun = function (params) {
  return https.post(`/util/code/getSmsCodeByAliyun`, params)
}
// 登录-注册
obj.register = function (params) {
  return https.post(`/restApi/member/auth/register`, params)
}
// 账号管理-申请子账号
obj.addMember = function (params) {
  return https.post(`/restApi/member/account/add`, params)
}
// 账号管理-账号列表
obj.listMember = function (params) {
  return https.post(`/restApi/member/account/list`, params)
}
// 账号管理-删除子账号
obj.deleteMember = function (params) {
  return https.post(`/restApi/member/account/delete`, params)
}
// 账号管理-修改备注
obj.updateRemark = function (params) {
  return https.post(`/restApi/member/account/update`, params)
}
// 地址-编辑
obj.updateAddress = function (params) {
  return https.post(`/restApi/address/update`, params)
}
// 地址-新增
obj.newAddress = function (params) {
  return https.post(`/restApi/address/add`, params)
}
// 地址-列表
obj.getAddressList = function (params) {
  return https.post(`/restApi/address/list`, params)
}
// 地址-详情
obj.getAddressDetail = function (params) {
  return https.post(`/restApi/address/detail`, params)
}
// 地址-删除
obj.deleteddress = function (params) {
  return https.post(`/restApi/address/delete`, params)
}
// 联系人-删除
obj.deleteContact = function (params) {
  return https.post(`/restApi/contact/delete`, params)
}
// 联系人-更新
obj.updateContact = function (params) {
  return https.post(`/restApi/contact/update`, params)
}
// 联系人-更新
obj.SupplierList = function (params) {
  return https.post(`/restApi/enterSupplierInformation/detail/my`, params)
}
//会员套餐列表
obj.MembershipPackageList = function (params) {
  return https.post(`/restApi/membershipPackage/list`, params)
}

//获取订单支付状态
obj.GetSaoPayStatus = function (params) {
  return https.post(`/restApi/vipRechargeRecord/getSaoPayStatus`, params)
}


export default obj